import { orchestrator } from 'satcheljs';
import { default as completeGetStartedTask } from '../actions/completeGetStartedTask';
import { GetStartedTaskId } from '../enums/GetStartedTaskId';
import { completePersonalization } from '../actions/completePersonalization';
import { getUserConfiguration } from 'owa-session-store';
import ReadingPanePosition from 'owa-session-store/lib/store/schema/ReadingPanePosition';

orchestrator(completePersonalization, () => {
    if (
        getUserConfiguration().UserOptions.GlobalReadingPanePositionReact !==
            ReadingPanePosition.Right ||
        getUserConfiguration().UserOptions.IsDarkModeTheme ||
        getUserConfiguration().UserOptions.DisplayDensityMode !== 'Full' ||
        (getUserConfiguration().UserOptions.ThemeStorageId !== '' &&
            getUserConfiguration().UserOptions.ThemeStorageId !== 'base')
    ) {
        completeGetStartedTask(GetStartedTaskId.CustomizeTheLook);
    }
});
